module.exports = __webpack_public_path__ + "static/media/purpleSocial.922827a6.svg";